import React, { useState } from "react";

const RebookReservationPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [rebookReservationPopup, setRebookReservationPopup] =
      useState<boolean>(false);

    const rebookReservationToggleHandler = () => {
      setRebookReservationPopup(!rebookReservationPopup);
    };

    return (
      <Component
        rebookReservationPopup={rebookReservationPopup}
        rebookReservationToggleHandler={rebookReservationToggleHandler}
        {...props}
      />
    );
  };

export default RebookReservationPopupHOC;
